import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const fetchQuestionnaireSections = async (type) => {
  const response = await axios.get(`${API}/questionnaire/sections?type=${type}`);
  return response.data;
};
